module.exports = __webpack_public_path__ + "static/media/logo.7ed9681d.svg";